import { useId, useState } from 'react';
import css from './service-cards.module.scss';
import ServiceCard from './service-card';
import PaginationCard from './service-pagination-card';
import { ServiceListProps } from 'src/types';

export default function ServiceCards({
  blockTitle,
  services,
  className,
  showCardsPagination,
  servicesLimit,
  onClick
}: Readonly<ServiceListProps>) {
  const serviceCardId = useId();
  const [selectedPage, setSelectedPage] = useState(1);
  const totalCount = services.length;

  if (totalCount === 0) {
    return null;
  }

  const offset = selectedPage * servicesLimit;
  const slicedServices = services.slice(0, offset);

  const hidePaginationCard = !showCardsPagination || slicedServices.length === totalCount;

  return (
    <div className={css.container}>
      <div className={css.title}>{blockTitle}</div>
      <div className={css.cards}>
        {slicedServices.map((service) => (
          <ServiceCard key={serviceCardId + service.id} service={service} className={className} onClick={onClick} />
        ))}
        {!hidePaginationCard && (
          <PaginationCard key={serviceCardId} onClick={() => setSelectedPage((prev) => prev + 1)} />
        )}
      </div>
    </div>
  );
}
